import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';

import {
  search,
  clearQueryParams,
  syncUrlParams,
  switchSearchFeatures,
} from '../../../../../../search/state/actions';
import { StateType } from '../../../../../../state/state.types';

const mapState = ({ results, queryParams }: StateType) => ({
  hits: results.hits,
  query: queryParams.userQuery,
  type: queryParams.type,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  resetSearchQuery(url: string) {
    dispatch(clearQueryParams());
    dispatch(syncUrlParams(url));
  },
  replaySearch(url: string, reason: string) {
    dispatch(syncUrlParams(url));
    dispatch(search({ reason, updateURL: false, allowEmptyQuery: true }));
  },
  switchSearchFeatures() {
    dispatch(switchSearchFeatures());
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
